import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_be73014c from 'nuxt_plugin_plugin_be73014c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_gtm_a4787774 from 'nuxt_plugin_gtm_a4787774' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtcookiecontrol_48b413a8 from 'nuxt_plugin_nuxtcookiecontrol_48b413a8' // Source: ./nuxt-cookie-control.js (mode: 'all')
import nuxt_plugin_axios_a60d3d20 from 'nuxt_plugin_axios_a60d3d20' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_image_cfff432a from 'nuxt_plugin_image_cfff432a' // Source: ./image.js (mode: 'all')
import nuxt_plugin_moment_00de5e28 from 'nuxt_plugin_moment_00de5e28' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_lazySizes_2cd55be8 from 'nuxt_plugin_lazySizes_2cd55be8' // Source: ./lazySizes.js (mode: 'all')
import nuxt_plugin_persistedStateclient_3b127e9c from 'nuxt_plugin_persistedStateclient_3b127e9c' // Source: ../../../plugins/persistedState.client.js (mode: 'client')
import nuxt_plugin_layouts_c273d278 from 'nuxt_plugin_layouts_c273d278' // Source: ../../../plugins/layouts.js (mode: 'all')
import nuxt_plugin_dataserver_5e6aa8f4 from 'nuxt_plugin_dataserver_5e6aa8f4' // Source: ../../../plugins/data.server.js (mode: 'server')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../../../plugins/filters.js (mode: 'all')
import nuxt_plugin_observeclient_844dc178 from 'nuxt_plugin_observeclient_844dc178' // Source: ../../../plugins/observe.client.js (mode: 'client')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../../../plugins/vee-validate (mode: 'all')
import nuxt_plugin_geolocateclient_4344b4cb from 'nuxt_plugin_geolocateclient_4344b4cb' // Source: ../../../plugins/geolocate.client.js (mode: 'client')
import nuxt_plugin_rudderclient_6a3c7344 from 'nuxt_plugin_rudderclient_6a3c7344' // Source: ../../../plugins/rudder.client.js (mode: 'client')
import nuxt_plugin_gtmclient_3751df48 from 'nuxt_plugin_gtmclient_3751df48' // Source: ../../../plugins/gtm.client.js (mode: 'client')
import nuxt_plugin_regionhandlerclient_7f27ef85 from 'nuxt_plugin_regionhandlerclient_7f27ef85' // Source: ../../../plugins/region-handler.client.js (mode: 'client')
import nuxt_plugin_cookiesclient_e5aac612 from 'nuxt_plugin_cookiesclient_e5aac612' // Source: ../../../plugins/cookies.client.js (mode: 'client')
import nuxt_plugin_regionurl_4b9f476b from 'nuxt_plugin_regionurl_4b9f476b' // Source: ../../../plugins/region-url.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"The TEFL Org","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"theme-color","content":"#309db6"},{"name":"facebook-domain-verification","content":"0lpmiu3g903imomm4hejvvh2hptkvv"}],"link":[{"rel":"preconnect","href":"\u002F\u002Fcdn-wp.tefl.org"},{"rel":"preconnect","href":"https:\u002F\u002Fuse.typekit.net","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fp.typekit.net","crossorigin":true},{"rel":"profile","href":"https:\u002F\u002Fgmpg.org\u002Fxfn\u002F11"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"}],"script":[{"hid":"olark","defer":true,"src":"\u002Folark.js"},{"hid":"klaviyo","defer":true,"src":"\u002F\u002Fstatic.klaviyo.com\u002Fonsite\u002Fjs\u002Fklaviyo.js?company_id=WQjuHK"},{"innerHTML":"window.console.log = () =\u003E { }"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.crossOrigin='true';j.async=true;j.src='https:\u002F\u002Fload.vic.tefl.org\u002Fdcxraehg.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-5K62LBG')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizers":["script"],"style":[],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_be73014c === 'function') {
    await nuxt_plugin_plugin_be73014c(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_a4787774 === 'function') {
    await nuxt_plugin_gtm_a4787774(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtcookiecontrol_48b413a8 === 'function') {
    await nuxt_plugin_nuxtcookiecontrol_48b413a8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_a60d3d20 === 'function') {
    await nuxt_plugin_axios_a60d3d20(app.context, inject)
  }

  if (typeof nuxt_plugin_image_cfff432a === 'function') {
    await nuxt_plugin_image_cfff432a(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_00de5e28 === 'function') {
    await nuxt_plugin_moment_00de5e28(app.context, inject)
  }

  if (typeof nuxt_plugin_lazySizes_2cd55be8 === 'function') {
    await nuxt_plugin_lazySizes_2cd55be8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistedStateclient_3b127e9c === 'function') {
    await nuxt_plugin_persistedStateclient_3b127e9c(app.context, inject)
  }

  if (typeof nuxt_plugin_layouts_c273d278 === 'function') {
    await nuxt_plugin_layouts_c273d278(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_dataserver_5e6aa8f4 === 'function') {
    await nuxt_plugin_dataserver_5e6aa8f4(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_observeclient_844dc178 === 'function') {
    await nuxt_plugin_observeclient_844dc178(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_geolocateclient_4344b4cb === 'function') {
    await nuxt_plugin_geolocateclient_4344b4cb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_rudderclient_6a3c7344 === 'function') {
    await nuxt_plugin_rudderclient_6a3c7344(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtmclient_3751df48 === 'function') {
    await nuxt_plugin_gtmclient_3751df48(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_regionhandlerclient_7f27ef85 === 'function') {
    await nuxt_plugin_regionhandlerclient_7f27ef85(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookiesclient_e5aac612 === 'function') {
    await nuxt_plugin_cookiesclient_e5aac612(app.context, inject)
  }

  if (typeof nuxt_plugin_regionurl_4b9f476b === 'function') {
    await nuxt_plugin_regionurl_4b9f476b(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
